import React, { useState } from 'react';
import Text from '../../../../../Components/Base/Text/Text';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import CaseTypeDetailModal from '../Detail/CaseTypeDetailModal';
import CaseTypeOrganizationUnitModal from '../OrganizationUnit/CaseTypeOrganizationUnitModal';
import ServiceScheduleNotificationModal from '../ServiceScheduleNotification/ServiceScheduleNotificationModal';
import { getShouldBeHintDisplayed } from '../../../Services/manager.service';

// @ts-ignore
import styles from './CaseTypeListHeader.module.scss';

interface Props {
	workplaceId: string;
	reloadList: () => void;
	isOnlyOneRoot: boolean;
}
const CaseTypeList: React.FC<Props> = ({
	workplaceId,
	reloadList,
	isOnlyOneRoot,
}) => {
	const [
		isServiceScheduleNotificationOpen,
		setIsServiceScheduleNotificationOpen,
	] = useState(false);
	const [isCaseTypeDetailOpen, setIsCaseTypeDetailOpen] = useState(false);
	const [isOrganizationUnitDetailOpen, setIsOrganizationUnitTypeDetailOpen] =
		useState(false);

	const handleCreateCaseType = () => {
		setIsCaseTypeDetailOpen(true);
	};

	const handleCreateOrganizationUnit = () => {
		setIsOrganizationUnitTypeDetailOpen(true);
	};

	const handleCaseTypeCreateSuccess = (canBookOnline: boolean) => {
		setIsCaseTypeDetailOpen(false);
		if (canBookOnline) {
			if (
				getShouldBeHintDisplayed('doNoShowServiceScheduleNotificationModal')
			) {
				setIsServiceScheduleNotificationOpen(true);
			} else {
				reloadList();
			}
		} else {
			reloadList();
		}
	};

	const handleOrganizationUnitCreateSuccess = () => {
		setIsOrganizationUnitTypeDetailOpen(false);
		reloadList();
	};

	const handleOnConfirmationClose = () => {
		setIsOrganizationUnitTypeDetailOpen(false);
		setIsServiceScheduleNotificationOpen(false);
		reloadList();
	};

	const handleBeforeConfirmationRedirect = () => {
		setIsOrganizationUnitTypeDetailOpen(false);
		setIsServiceScheduleNotificationOpen(false);
	};

	return (
		<div className={styles.wrapper}>
			<Text tx='component.caseType.text1' className={styles.title} />
			<div className={styles.controls}>
				<Button
					theme={Theme.BLUE}
					title='component.caseType.createNewManagementUnit'
					onClick={handleCreateOrganizationUnit}
				/>
				{isOrganizationUnitDetailOpen && (
					<CaseTypeOrganizationUnitModal
						isOpened
						onClose={handleOnConfirmationClose}
						workplaceId={workplaceId}
						onSuccess={handleOrganizationUnitCreateSuccess}
						isOnlyOneRoot={isOnlyOneRoot}
					/>
				)}
				<Button
					theme={Theme.GREEN}
					title='component.caseType.createNewCaseType'
					onClick={handleCreateCaseType}
				/>
				{isCaseTypeDetailOpen && (
					<CaseTypeDetailModal
						isOpened
						onClose={() => setIsCaseTypeDetailOpen(false)}
						workplaceId={workplaceId}
						onSuccess={handleCaseTypeCreateSuccess}
						isOnlyOneRoot={isOnlyOneRoot}
					/>
				)}
				{isServiceScheduleNotificationOpen && (
					<ServiceScheduleNotificationModal
						isOpened={isServiceScheduleNotificationOpen}
						onClose={handleOnConfirmationClose}
						beforeRedirect={handleBeforeConfirmationRedirect}
					/>
				)}
			</div>
		</div>
	);
};

export default CaseTypeList;
